import { moveItemAtIndexInSelection, swapItemWithNextInSelection } from '@lifen-sending/utils';
import { createReducer, PayloadAction } from '@reduxjs/toolkit';

import {
  MoveInsideSelectionPayload,
  moveDownInsideSelection,
  moveUpInsideSelection,
  RemoveFromSelection,
  RemoveManyFromSelection,
  removeFromSelection,
  removeManyFromSelection,
  SetPositionInsideSelection,
  setPositionInsideSelection,
  UpdateSelection,
  updateSelection,
} from './selection.action';
import { INITIAL_SELECTION_STATE, SelectionState } from './selection.state';

function updateSelectionState(
  state: SelectionState,
  action: ReturnType<UpdateSelection>,
): SelectionState {
  return {
    ...state,
    [action.payload.dashboard]: action.payload.ids,
  };
}

function removeItemFromSelection(
  state: SelectionState,
  action: ReturnType<RemoveFromSelection>,
): SelectionState {
  const currentSelection = state[action.payload.dashboard];
  const index = currentSelection.indexOf(action.payload.id);
  if (index < 0) {
    return state;
  }

  const selection = [...currentSelection];
  selection.splice(index, 1);

  return {
    ...state,
    [action.payload.dashboard]: selection,
  };
}

function removeItemsFromSelection(
  state: SelectionState,
  action: ReturnType<RemoveManyFromSelection>,
): SelectionState {
  const { dashboard, ids } = action.payload;
  const currentSelection = state[dashboard];

  if (ids.length === 0) {
    return state;
  }

  const selection = currentSelection.filter((id) => !ids.includes(id));

  return {
    ...state,
    [dashboard]: selection,
  };
}

function moveItemDownInsideSelection(
  state: SelectionState,
  action: PayloadAction<MoveInsideSelectionPayload>,
): SelectionState {
  const currentSelection = state[action.payload.dashboard];
  const index = currentSelection.indexOf(action.payload.id);
  if (index < 0 || index > currentSelection.length - 2) {
    return state;
  }

  const selection = swapItemWithNextInSelection(currentSelection, index);

  return {
    ...state,
    [action.payload.dashboard]: selection,
  };
}

function moveItemUpInsideSelection(
  state: SelectionState,
  action: PayloadAction<MoveInsideSelectionPayload>,
): SelectionState {
  const currentSelection = state[action.payload.dashboard];
  const index = currentSelection.indexOf(action.payload.id);
  if (index < 1) {
    return state;
  }

  const selection = swapItemWithNextInSelection(currentSelection, index - 1);

  return {
    ...state,
    [action.payload.dashboard]: selection,
  };
}

function setItemPositionInsideSelection(
  state: SelectionState,
  action: ReturnType<SetPositionInsideSelection>,
): SelectionState {
  const currentSelection = state[action.payload.dashboard];
  const newIndex = action.payload.position;

  const selection = moveItemAtIndexInSelection(currentSelection, action.payload.item, newIndex);

  return {
    ...state,
    [action.payload.dashboard]: selection,
  };
}

export const selectionReducer = createReducer(INITIAL_SELECTION_STATE, {
  [updateSelection.type]: updateSelectionState,
  [moveDownInsideSelection.type]: moveItemDownInsideSelection,
  [moveUpInsideSelection.type]: moveItemUpInsideSelection,
  [setPositionInsideSelection.type]: setItemPositionInsideSelection,
  [removeFromSelection.type]: removeItemFromSelection,
  [removeManyFromSelection.type]: removeItemsFromSelection,
});
